<div class="seo_content seo_content--module container-p9" *ngIf="isToShowBanner">
	<div class="container">
		<div class="row">
			<div id="bannerContent"></div>
		</div>
	</div>
</div>